import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useCursorUtils() {
    var _a = React.useState(), cursorElement = _a[0], setCursorElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || cursorElement)
            return;
        var loadedCursorElement = client.getCursorElement();
        setCursorElement(loadedCursorElement);
    }, [client, setCursorElement, cursorElement]);
    return cursorElement;
}
export function useCursorUsers() {
    var cursorElement = useCursorUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!cursorElement)
            return;
        var subscription = cursorElement.getOnlineUsersOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [cursorElement]);
    return data;
}
